<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-briefcase</v-icon> <span>{{$t('work_units.crumb_add')}}</span>
      </h1>

      <div class="mt-16">
        <unit method="create"></unit>
      </div>
  </section>
</template>
<script>
import Unit from '@/components/units/Unit'

export default {
  components: {
    Unit
  },
  beforeCreate(){
    document.title = "Report Lake - " + this.$t('work_units.crumb_add');
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "units.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.work_units_management'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin/elements/units',
          exact: true,
        },
        {
          text: this.$t('work_units.crumb_add'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
